import { render, staticRenderFns } from "./usergroup-monitoring-service.vue?vue&type=template&id=859f4fd4&scoped=true"
import script from "./usergroup-monitoring-service.vue?vue&type=script&lang=js"
export * from "./usergroup-monitoring-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859f4fd4",
  null
  
)

export default component.exports